import * as signals from "signals";
import { Signals } from "@/Imports";

export default {
  realityCheck: new signals.Signal(),
  gameStarted: new signals.Signal(),
  gameInited: new signals.Signal(),
  orientationChanged: new signals.Signal(),
  loadAssets: new signals.Signal(),
  loadingProgress: new signals.Signal(),
  textAssetsLoadingComplete: new signals.Signal(),
  preloaderAssetsLoadingComplete: new signals.Signal(),
  mainGameAssetsLoadingComplete: new signals.Signal(),
  continueBtnClick: new signals.Signal(),
  muteAll: new signals.Signal(),
  errorMessage: new signals.Signal(),
  makeBet: new signals.Signal(),

  playerWin: new signals.Signal(),
  playerConnect: new signals.Signal(),

  urlSettings: new signals.Signal(),

  currentBetHasChanged: new signals.Signal(),
  currentAutoCollectHasChanged: new signals.Signal(),

  stateChanged: new signals.Signal(),

  //SERVER SIGNALS
  serverMessage: new signals.Signal(),
  backendMessage: new signals.Signal(),
  gameMessage: new signals.Signal(),
  getGameInit: new signals.Signal(),

  autoBetButtonClicked: new signals.Signal(),

  startPlane: new signals.Signal(),

  initGame: new signals.Signal(),
  socketClosed: new signals.Signal(),
  socketOpened: new signals.Signal(),
  getGameSpin: new signals.Signal(),
  spinResponse: new signals.Signal(),
  sessionTimeout: new signals.Signal(),
  errorConnection: new signals.Signal(),
  setBetStatus: new signals.Signal(),
  playersStateChanged: new signals.Signal(),
  setMakeBet: new signals.Signal(),
  multipliersHistory: new signals.Signal(),
  playerTakeWin: new signals.Signal(),
  betsUpdates: new signals.Signal(),
  resetBets: new signals.Signal(),

  tick: new signals.Signal(),
  tickerStart: new signals.Signal(),
  tickerStop: new signals.Signal(),
  startFly: new signals.Signal(),
  stopFly: new signals.Signal(),

  forceIdle: new signals.Signal(),
  forceRoundStart: new signals.Signal(),
  forceRoundEnd: new signals.Signal(),
  forceMakeBets: new signals.Signal(),
  autoCollectHappened: new signals.Signal(),

  makeBets: new signals.Signal(),
  roundStart: new signals.Signal(),
  roundEnd: new signals.Signal(),

  multiplier: new signals.Signal(),

  //MODEL SIGNALS
  notEnoughMoney: new signals.Signal(),
  graphicsCreated: new signals.Signal(),
  modelInitStored: new signals.Signal(),
  balanceUpdate: new signals.Signal(),
  setWin: new signals.Signal(),
  onWin: new signals.Signal(),

  //Feature
  startFeature: new signals.Signal(),
  stopFeature: new signals.Signal(),
  showfreebets: new signals.Signal(),
  featureServerHappened: new signals.Signal(),

  //UI Signals
  UIisReady: new signals.Signal(),
  initUI: new signals.Signal(),
  spinBtnPressed: new signals.Signal(),

  requestFullScreen: new signals.Signal(),

  musicClick: new signals.Signal(),
  soundClick: new signals.Signal(),
  muteClick: new signals.Signal(),

  chatVisibilityChange: new signals.Signal(),

  enableGamePopups: new signals.Signal(),
  disableGamePopups: new signals.Signal(),

  promo: new signals.Signal(),
  progressMakeBets: new signals.Signal(),
  onClose: new signals.Signal(),
};
